import React, { useEffect, useContext, useState, useRef } from 'react'

import Moment from 'moment'

import { Box, Button, Dialog, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField} from '@mui/material'

import { ReactComponent as XIcon } from '../../../../images/x-icon.svg'

Moment.locale('fr')

const DialogContent = ({ actPlan, allFormations, actCertification, setActCertification, haveToSave, canSave, onClose, saveCertification }) => {

  const [maxAnnee, setMaxAnnee] = useState(null)
  useEffect(() => {
    if (actPlan) {
      let arrAnnees = []
      actPlan.forEach((plan) => {
        let annee = parseInt(plan?.annee)
        if (annee && Number.isInteger(annee)) {
          arrAnnees.push(annee)
        }
      })
      if (arrAnnees.length > 0) {
        setMaxAnnee(Math.max(...arrAnnees))
      } else {
        setMaxAnnee(null)
      }
    }
  }, [actPlan])


  const [valuesForNiveauConnaissance, setValuesForNiveauConnaissance] = useState(null)

  useEffect(() => {
    let find = actCertification?.find((el) => el.id === "valuesForNiveauConnaissance")
    if (find) {
      setValuesForNiveauConnaissance(find)
    }

  }, [actCertification])

  return (
    <Box sx={{
      padding:"20px",
    }}>
      <Box sx={{display:"flex", justifyContent:"flex-end"}}>
        <XIcon width="20px" height="20px" onClick={onClose} style={{
          cursor:"pointer",
          color:"black"
        }}/>
      </Box>
      <Box sx={{display:"flex", flexDirection:"column", alignItems:"center", gap:"15px"}}>
        <Box sx={{fontSize:"27px", fontWeight:"bold", textAlign:"center"}}>
          Gestion de la certification
        </Box>
      </Box>
      <Box sx={{padding:"0px 10px", display:"flex", flexDirection:"column", gap:"15px"}}>
        <Box>
          <Box sx={{fontSize:"18px", marginBottom:"5px"}}>
            <font style={{fontWeight:"bold"}}>NIVEAU DE CONNAISSANCE</font>&nbsp;:
          </Box>
          <Box sx={{marginLeft:"15px", marginRight:"15px"}}>
            <Box>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{width:"300px"}}>Name</TableCell>
                      <TableCell align="center">
                        Seuil validation (>= %)
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                          <TableCell sx={{width:"300px"}}>
                            Avant la formation
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              value={valuesForNiveauConnaissance?.before !== undefined ? valuesForNiveauConnaissance.before : ""}
                              size="small"
                              type="number"
                              inputProps={{
                                step: 1,
                                max : 100,
                                min : 0,
                              }}
                              sx={{
                                width:"60px",
                                height:"40px",
                                ".MuiInputBase-input" : {
                                  padding:"5px",
                                  textAlign:"right",
                                },
                              }}
                              onChange={(e) => {
                                let newVal = e.target.value
                                if (newVal === "") { newVal = 0}
                                if (newVal > 100) { newVal = 100}
                                if (newVal <= 0) { newVal = 0}
                                newVal = parseInt(newVal)
                                //on cherche dans la certicication
                                let find = actCertification?.find((el) => el.id === "valuesForNiveauConnaissance")
                                if (find) {
                                  let newCertif = JSON.parse(JSON.stringify(actCertification))
                                  let find2 = newCertif?.find((el) => el.id === "valuesForNiveauConnaissance")
                                  find2.before = newVal
                                  setActCertification(newCertif)
                                } else { //on créé
                                  let newCertif = JSON.parse(JSON.stringify(actCertification))
                                  newCertif.push({
                                    id : "valuesForNiveauConnaissance",
                                    before : newVal,
                                    after : 0,
                                  })
                                  setActCertification(newCertif)
                                }
                              }}
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                          <TableCell sx={{width:"300px"}}>
                            Après la formation
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              value={valuesForNiveauConnaissance?.after !== undefined ? valuesForNiveauConnaissance.after : ""}
                              size="small"
                              type="number"
                              inputProps={{
                                step: 1,
                                max : 100,
                                min : 0,
                              }}
                              sx={{
                                width:"60px",
                                height:"40px",
                                ".MuiInputBase-input" : {
                                  padding:"5px",
                                  textAlign:"right",
                                },
                              }}
                              onChange={(e) => {
                                let newVal = e.target.value
                                if (newVal === "") { newVal = 0}
                                if (newVal > 100) { newVal = 100}
                                if (newVal <= 0) { newVal = 0}
                                newVal = parseInt(newVal)
                                //on cherche dans la certicication
                                let find = actCertification?.find((el) => el.id === "valuesForNiveauConnaissance")
                                if (find) {
                                  let newCertif = JSON.parse(JSON.stringify(actCertification))
                                  let find2 = newCertif?.find((el) => el.id === "valuesForNiveauConnaissance")
                                  find2.after = newVal
                                  setActCertification(newCertif)
                                } else { //on créé
                                  let newCertif = JSON.parse(JSON.stringify(actCertification))
                                  newCertif.push({
                                    id : "valuesForNiveauConnaissance",
                                    before : 0,
                                    after : newVal,
                                  })
                                  setActCertification(newCertif)
                                }
                              }}
                            />
                          </TableCell>
                        </TableRow>


                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </Box>
        {actPlan && actPlan.map((plan, index) => {
          let thisFormation = allFormations?.find((el) => el.id === plan.id)
          let softSkillsList = []
          if (thisFormation && thisFormation.softSkills) {
            try {
              softSkillsList = JSON.parse(thisFormation.softSkills)
            } catch(e) { }
          }
          softSkillsList = softSkillsList.filter((el) => el.value === "oui")

          return (
            <Box key={index}>
              <Box sx={{fontSize:"18px", marginBottom:"5px"}}>
                <font style={{fontWeight:"bold"}}>{plan.name}&nbsp;&nbsp;</font>
                (Année {plan.annee}{parseInt(plan.annee) === maxAnnee && ", dernière année"})&nbsp;:

              </Box>
              <Box sx={{marginLeft:"15px", marginRight:"15px"}}>
                {softSkillsList.length === 0 &&
                  <font style={{fontStyle:"italic"}}>Aucun softskills</font>
                }
                {softSkillsList.length > 0 &&
                  <Box>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{width:"300px"}}>Name</TableCell>
                            <TableCell align="center">
                              Seuil validation (>= %)
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {softSkillsList.map((skill, indexSkill) => {
                            let actCertifSkills = actCertification?.find((el) => el.id === plan.id)?.softSkills?.find((el) => el.key === skill.key)
                            return(
                              <TableRow
                                key={indexSkill}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                              >
                                <TableCell sx={{width:"300px"}}>
                                  {skill.key}
                                </TableCell>
                                <TableCell align="center">
                                  <TextField
                                    value={actCertifSkills?.validation !== undefined ? actCertifSkills?.validation : ""}
                                    size="small"
                                    type="number"
                                    inputProps={{
                                      step: 1,
                                      max : 100,
                                      min : 0,
                                    }}
                                    sx={{
                                      width:"60px",
                                      height:"40px",
                                      ".MuiInputBase-input" : {
                                        padding:"5px",
                                        textAlign:"right",
                                      },
                                    }}
                                    onChange={(e) => {
                                      let newVal = e.target.value
                                      if (newVal === "") { newVal = 0}
                                      if (newVal > 100) { newVal = 100}
                                      if (newVal <= 0) { newVal = 0}
                                      newVal = parseInt(newVal)
                                      if (actCertifSkills) {
                                        let newCertif = JSON.parse(JSON.stringify(actCertification))
                                        let actVal = newCertif.find((el) => el.id === plan.id)?.softSkills?.find((el) => el.key === skill.key)
                                        actVal.validation = newVal
                                        setActCertification(newCertif)
                                      } else {
                                        let newKey = {key : skill.key, validation : newVal}
                                        let newCertif = JSON.parse(JSON.stringify(actCertification))
                                        newCertif?.find((el) => el.id === plan.id)?.softSkills?.push(newKey)
                                        setActCertification(newCertif)
                                      }
                                    }}
                                  />
                                </TableCell>
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                }
              </Box>
            </Box>
          )
        })}
      </Box>
      <Box sx={{display:"flex", justifyContent:"center", marginTop:"40px"}}>
        <Button
          disabled={(haveToSave === true && canSave === true) ? false : true}
          variant="contained"
          size="large"
          sx={{ minHeight:"35px !important" }}
          onClick={() => {
            saveCertification(actCertification)
          }}
        >
          Enregistrer
        </Button>
      </Box>
    </Box>
  )
}


const CertificationModal = ({isOpen, onClose, groupState, saveCertification}) => {

  const [step, setStep] = useState(0)

  const [actPlan, setActPlan] = useState(null)
  const [allFormations, setAllFormations] = useState(null)
  const [actCertification, setActCertification] = useState(null)

  const [haveToSave, setHaveToSave] = useState(false)
  const [canSave, setCanSave] = useState(false)

  useEffect(() => {
    //console.log(groupState)
    if (groupState.plan) {
      try {
        let plan = JSON.parse(JSON.stringify(groupState.plan))
        plan = plan.filter((el) => {
          try {
            if (parseInt(el.annee) >=1 && parseInt(el.annee) <=5) {
              return true
            } else {
              return false
            }
          } catch { return false }
        })
        setActPlan(plan)
        if (groupState.allFormations) {
          setAllFormations(groupState.allFormations)
        }
        if (groupState.certification) {
          let verifCertification = JSON.parse(JSON.stringify(groupState.certification))
          let isOK = true
          plan.forEach((p) => {
            let find = verifCertification.find((el) => el.id === p.id)
            if (!find) {
              isOK = false
              verifCertification.push({id : p.id, softSkills : []})
            }
          })
          if (isOK === false) {
            groupState.initialCertification = verifCertification
          }
          setActCertification(verifCertification)
        } else {
          let newCertification = []
          plan.forEach((p) => {
            newCertification.push({id : p.id, softSkills : []})
          })
          groupState.initialCertification = newCertification
          setActCertification(newCertification)
        }
      } catch(e) { console.log(e) }
    }
  }, [groupState])

  useEffect(() => {
    if (actPlan && actCertification && groupState) {
      if (JSON.stringify(actCertification) !== JSON.stringify(groupState.initialCertification)) {
        setHaveToSave(true)
        //on doit vérifier pour chaque skills de chaque formation si on a bien un chiffre en seuil de validation
        let isOK = true
        for (let p=0; p < actPlan.length; p++) {
          let plan = actPlan[p]
          let thisFormation = allFormations?.find((el) => el.id === plan.id)
          let softSkillsList = []
          if (thisFormation && thisFormation.softSkills) {
            try {
              softSkillsList = JSON.parse(thisFormation.softSkills)
            } catch(e) { }
          }
          softSkillsList = softSkillsList.filter((el) => el.value === "oui")
          for (let s=0; s < softSkillsList.length; s++) {
            let actCertifSkills = actCertification?.find((el) => el.id === plan.id)?.softSkills?.find((el) => el.key === softSkillsList[s].key)
            if (actCertifSkills) {
              if (Number.isInteger(actCertifSkills?.validation)) {
                isOK = true;
              } else {
                isOK = false;
                break;
              }
            } else {
              isOK = false;
              break;
            }
          }
        }
        setCanSave(isOK)
      } else {
        setHaveToSave(false)
        setCanSave(false)
      }
    }
  }, [actCertification, groupState, actPlan])


  return (
    <Dialog
      fullWidth={true}
      maxWidth="xl"
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx : {
          color:"black",
        }
      }}
    >
      <DialogContent
        actPlan={actPlan}
        allFormations={allFormations}
        actCertification={actCertification}
        setActCertification={setActCertification}
        onClose={onClose}
        haveToSave={haveToSave}
        canSave={canSave}
        saveCertification={saveCertification}
      />
    </Dialog>
  )
}

export default CertificationModal
